module.exports = __webpack_public_path__ + "static/media/Inclined-Kids3.18dac3b1.jpg";